module.exports = "https://la-static.vkplay.ru/promo/newstart/img/gunslinger.ed90b7a4.png";